// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'magnet-solid';

export const Component = () => (
  <path d='M22.594 1h-5.89v13.219c0 1.197-.432 2.25-1.294 3.113-.862.91-1.915 1.34-3.113 1.34s-2.25-.43-3.113-1.34c-.862-.862-1.293-1.916-1.293-3.113V1H2v13.219c0 2.826 1.005 5.268 3.017 7.28 2.012 2.011 4.454 3.017 7.28 3.017 2.826 0 5.268-1.006 7.28-3.018 2.011-2.011 3.017-4.453 3.017-7.28V1Zm-15.71.958V3.92H2.957V1.958h3.927Zm14.752 0V3.92h-3.927V1.958h3.927Z' />
);

export const viewBox = '0 0 25 25';
